
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vender/[venderUrlId]/contact",
      function () {
        return require("private-next-pages/vender/[venderUrlId]/contact/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vender/[venderUrlId]/contact"])
      });
    }
  